import React, { useEffect } from "react";
import { PRACTICE_INFO } from "@/site-data";

interface SEOProps {
  title: string;
  description: string;
  canonicalPath?: string;
  schema?: object;
}

export function SEOHead({ title, description, canonicalPath = "/", schema }: SEOProps) {
  useEffect(() => {
    // Set document title
    document.title = title;

    // Set meta description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement("meta");
      metaDesc.setAttribute("name", "description");
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute("content", description);

    // Set canonical link
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    const cleanCanonical = `https://www.drspenceharper.com${canonicalPath}`;
    canonical.setAttribute("href", cleanCanonical);

    // Add or update JSON-LD script tag
    let scriptTag = document.getElementById("jsonld-structured-data") as HTMLScriptElement;
    if (!scriptTag) {
      scriptTag = document.createElement("script");
      scriptTag.id = "jsonld-structured-data";
      scriptTag.type = "application/ld+json";
      document.head.appendChild(scriptTag);
    }

    const defaultSchema = {
      "@context": "https://schema.org",
      "@type": ["MedicalClinic", "LocalBusiness"],
      name: PRACTICE_INFO.name,
      legalName: PRACTICE_INFO.legalName,
      url: "https://www.drspenceharper.com/",
      telephone: PRACTICE_INFO.phone,
      address: {
        "@type": "PostalAddress",
        streetAddress: PRACTICE_INFO.address.street,
        addressLocality: PRACTICE_INFO.address.city,
        addressRegion: PRACTICE_INFO.address.state,
        postalCode: PRACTICE_INFO.address.zip,
        addressCountry: PRACTICE_INFO.address.country
      },
      geo: {
        "@type": "GeoCoordinates",
        latitude: 40.5097,
        longitude: -111.4133
      },
      openingHoursSpecification: [
        {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: ["Monday", "Tuesday", "Thursday"],
          opens: "08:00",
          closes: "17:00"
        }
      ],
      medicalSpecialty: "Podiatric",
      physician: {
        "@type": "Physician",
        name: PRACTICE_INFO.doctor,
        medicalSpecialty: "Podiatrist",
        jobTitle: PRACTICE_INFO.doctorTitle,
        alumniOf: [
          {
            "@type": "EducationalOrganization",
            name: "Temple University School of Podiatric Medicine"
          },
          {
            "@type": "EducationalOrganization",
            name: "University of Utah"
          }
        ]
      }
    };

    scriptTag.text = JSON.stringify(schema || defaultSchema);
  }, [title, description, canonicalPath, schema]);

  return null;
}
